import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ScheduledMessages = ({ scheduledMessages, currentLanguage, onCancelSchedule, onEditSchedule }) => {
  const labels = {
    fr: {
      title: 'Messages planifiés',
      noScheduled: 'Aucun message planifié',
      scheduledFor: 'Planifié pour',
      recipients: 'destinataires',
      cancel: 'Annuler',
      edit: 'Modifier',
      sendNow: 'Envoyer maintenant'
    },
    ar: {
      title: 'الرسائل المجدولة',
      noScheduled: 'لا توجد رسائل مجدولة',
      scheduledFor: 'مجدول لـ',
      recipients: 'مستلم',
      cancel: 'إلغاء',
      edit: 'تعديل',
      sendNow: 'إرسال الآن'
    }
  };

  const getMessageTypeIcon = (type) => {
    const icons = {
      email: 'Mail',
      whatsapp: 'MessageCircle',
      sms: 'Smartphone'
    };
    return icons?.[type] || 'Mail';
  };

  const formatScheduledDate = (date, time) => {
    const scheduledDate = new Date(`${date}T${time}`);
    // Always use en-US locale for universal date/time format (Western numerals)
    return scheduledDate?.toLocaleString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center">
          <Icon name="Clock" size={20} className="text-warning" />
        </div>
        <h2 className="text-lg md:text-xl font-semibold text-foreground">
          {labels?.[currentLanguage]?.title}
        </h2>
      </div>
      {scheduledMessages?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="Calendar" size={48} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-muted-foreground">{labels?.[currentLanguage]?.noScheduled}</p>
        </div>
      ) : (
        <div className="space-y-4">
          {scheduledMessages?.map((message) => (
            <div
              key={message?.id}
              className="border border-border rounded-lg p-4 hover:shadow-warm transition-smooth"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-warning/10 flex items-center justify-center">
                  <Icon name={getMessageTypeIcon(message?.type)} size={20} className="text-warning" />
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-foreground mb-1 truncate">
                    {message?.subject}
                  </h3>
                  <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
                    {message?.preview}
                  </p>

                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 caption text-muted-foreground mb-3">
                    <span className="inline-flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      {labels?.[currentLanguage]?.scheduledFor}: {formatScheduledDate(message?.scheduledDate, message?.scheduledTime)}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <Icon name="Users" size={14} />
                      {message?.recipientCount} {labels?.[currentLanguage]?.recipients}
                    </span>
                  </div>

                  <div className="flex flex-wrap gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="Edit"
                      iconPosition="left"
                      onClick={() => onEditSchedule?.(message?.id)}
                    >
                      {labels?.[currentLanguage]?.edit}
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="Send"
                      iconPosition="left"
                    >
                      {labels?.[currentLanguage]?.sendNow}
                    </Button>
                    <Button
                      variant="destructive"
                      size="sm"
                      iconName="X"
                      iconPosition="left"
                      onClick={() => onCancelSchedule?.(message?.id)}
                    >
                      {labels?.[currentLanguage]?.cancel}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ScheduledMessages;